<script lang="ts">
    import {KpPopoverPanel} from 'shared/ui-widgets/popover';
    import type {ButtonStyle, ComponentSize} from 'shared/ui-widgets/types';
    import type {Placement} from '@floating-ui/core';
    import {Menu, MenuButton, MenuItems} from '@rgossiaux/svelte-headlessui';
    import {createFloatingActions} from 'svelte-floating-ui';
    import {floatingUiCommonSettings} from 'shared/utils/floating-ui-common-settings';
    import {exists, uuid as generateUuid} from 'shared/utils/custom-utils';
    import {tooltip} from 'shared/ui-widgets/tooltip/use.tooltip';

    export let buttonStyle: ButtonStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let isDisabled = false;
    export let isBlock = false;
    export let additionalButtonClasses = '';
    export let additionalContainerClasses = '';
    export let additionalMenuClasses = '';
    export let id: string | null = generateUuid();
    export let dataQa: string | null = null;
    export let noWrap = false;
    export let useBootstrapStyles = true;
    export let defaultPlacement: Placement = 'bottom-end';
    export let tooltipLabel: string | null = null;

    const [floatingRef, floatingContent] = createFloatingActions(floatingUiCommonSettings(defaultPlacement, 2));

    $: buttonId = `${id}-dropdown-menu-button`;
    $: panelId = `${id}-dropdown-menu-panel`;

    const buttonClass = `btn btn-${buttonStyle} btn-${buttonSize} ${isBlock ? 'btn-block' : ''}`;
</script>

<Menu as="span"
      class="kp-dropdown-button btn-group {isBlock ? 'btn-block' : ''} {additionalContainerClasses}"
      use={[floatingRef, [tooltip, {enabled: exists(tooltipLabel), content: tooltipLabel ?? '', role: 'tooltip'}]]}
      let:open>

    <MenuButton id={buttonId}
                disabled={isDisabled}
                data-qa={dataQa}
                class="{useBootstrapStyles ? buttonClass : ''} dropdown-toggle {additionalButtonClasses} {noWrap ? 'no-text-wrap' : ''}">

        <slot name="button"/>
    </MenuButton>

    <KpPopoverPanel {open}
                    popoverMode="manual"
                    id={panelId}
                    use={[floatingContent]}>

        <MenuItems as="ul"
                   class="dropdown-menu-items {additionalMenuClasses}"
                   static>

            <slot name="menu"/>
        </MenuItems>
    </KpPopoverPanel>
</Menu>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    :global {
        .kp-dropdown-button {
            white-space: normal;

            .no-text-wrap {
                white-space: nowrap;
            }

            .kp-popover-panel {
                --popover-content-padding: @spacing-s;
            }

            .dropdown-menu-items {
                display: flex;
                flex-direction: column;
                min-width: 200px;
                max-height: 400px;
                overflow-y: auto;
            }
        }
    }
</style>